module.exports = __webpack_public_path__ + "static/legends-6-c4510d1bd41ae5adbc29bfc08183a5f8.jpg";